import styles from './PunchupFormToggle.module.css';

import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { PunchupFieldHelp, PunchupFieldHelpIcon } from '../PunchupFieldLabel';

interface PunchupFormToggleProps {
	htmlFor: string;
	name: string;
	label?: string;
	info?: string;
	/**
	 * Optional tooltip beside the label. `info` stays the always-visible one-line promise; add `help` only
	 * when the toggle carries mechanics or an example the info line cannot hold.
	 */
	help?: PunchupFieldHelp;
}

export const PunchupFormToggle: FC<PunchupFormToggleProps> = ({ htmlFor, name, label, info, help }) => {
	const { register } = useFormContext();

	return (
		<div className={styles.container}>
			<div className={styles.labelContainer}>
				{label && (
					<div className={styles.labelRow}>
						<label htmlFor={htmlFor} className={styles.label}>
							{label}
						</label>
						{help && <PunchupFieldHelpIcon help={help} ariaLabel={`${label} — more information`} />}
					</div>
				)}
				{info && <div className={styles.info}>{info}</div>}
			</div>

			<label className={styles.toggle}>
				<input type="checkbox" id={htmlFor} {...register(name)} />
				<span className={styles.slider} />
			</label>
		</div>
	);
};
